import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper,
  Checkbox,
} from '@material-ui/core';
import CommonTableToolbar from '../../CommonComponents/TableComponents/CommonTableToolBar';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import { CommonButton, CommonModal } from '../../CommonComponents';
import { assignFlexReceiveDate } from '../../redux/actions/sites';
import FallbackCard from '../../CommonComponents/FallbackCard';

const title = 'All sites list';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: 'Site Id',
  },
  {
    id: 'mediaTypeName',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'stateName',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    disablePadding: false,
    label: 'Location',
    width: '20%',
  },
  {
    id: 'startDate',
    numeric: true,
    disablePadding: false,
    label: 'Start Date',
  },
  {
    id: 'endDate',
    numeric: true,
    disablePadding: false,
    label: 'End Date',
  },
  {
    id: 'supplierName',
    numeric: true,
    disablePadding: false,
    label: 'Supplier',
  },
  {
    id: 'FlexReceiveDate',
    numeric: true,
    disablePadding: false,
    label: 'Flex Receive Date',
  },
  {
    id: 'frequency',
    numeric: true,
    disablePadding: false,
    label: 'Frequency',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    marginRight: 20,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
}));

const FlexDateTable = ({
  allSites,
  currentPageCount,
  selected,
  setSelected,
  setCheckbox,
  checkBoxState,
  assignFlexDate,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId');
  const [page] = useState(0);
  const [newStartDate, setNewStartDate] = useState(null);
  const [updateFlexReceiveDate, setUpdateFlexReceiveDate] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (checkBoxState) {
      if (event.target.checked) {
        const newSelecteds = allSites.map((obj) => obj.id);
        setSelected(newSelecteds);
        setCheckbox(false);
      }
    } else {
      setCheckbox(true);
      setSelected([]);
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleDayClick = (day) => {
    setNewStartDate(day);
  };

  const addFlexReceiveDate = () => {
    const siteId = selected;
    assignFlexDate({
      siteId,
      newDate: newStartDate,
    });
    setNewStartDate(null);
    setSelected([]);
    setUpdateFlexReceiveDate(false);
  };

  const userType = JSON.parse(localStorage.getItem('user'));
  const numSelected = selected.length;
  const canChangeFlexDate =
    userType &&
    (userType.userType === 'admin' ||
      userType.userType === 'manager' ||
      userType.userType === 'supplier');
  return (
    <div className={classes.root}>
      {allSites.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <CommonTableToolbar>
              <div className="row fluid">
                <div className="col-7">
                  {numSelected > 0 ? (
                    <Typography
                      className={classes.title}
                      color="primary"
                      variant="subtitle1"
                      component="div"
                    >
                      {numSelected > 1
                        ? `${numSelected} sites selected `
                        : `${numSelected} site selected `}
                    </Typography>
                  ) : (
                    <Typography
                      className={classes.title}
                      variant="h6"
                      id="tableTitle"
                      component="div"
                    >
                      {title}
                    </Typography>
                  )}
                </div>
                <div className="col-4 ml-auto">
                  <TextField
                    className={classes.searchBar}
                    id="outlined-basic"
                    label="Search this page"
                    variant="outlined"
                  />
                </div>
              </div>
            </CommonTableToolbar>
            <div className="col-12">
              {canChangeFlexDate ? (
                <CommonButton
                  className={classes.assignButtonWidth}
                  disabled={numSelected === 0}
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => setUpdateFlexReceiveDate(true)}
                >
                  Assign Flex Receive Date
                </CommonButton>
              ) : null}
            </div>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={
                    canChangeFlexDate ? handleSelectAllClick : null
                  }
                  onRequestSort={handleRequestSort}
                  rowCount={allSites.length}
                  checkbox
                />
                <TableBody>
                  {stableSort(allSites, getComparator(order, orderBy))
                    .slice(
                      page * currentPageCount,
                      page * currentPageCount + currentPageCount
                    )
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            {canChangeFlexDate ? (
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                                onChange={(event) => handleClick(event, row.id)}
                              />
                            ) : null}
                          </TableCell>
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            {row.siteId}
                          </TableCell>
                          <TableCell>{row.mediaTypeName}</TableCell>
                          <TableCell>{row.stateName}</TableCell>
                          <TableCell>{row.cityName}</TableCell>
                          <TableCell>{row.locationName}</TableCell>
                          <TableCell align="center" padding="none">
                            {moment(
                              row.newStartDate
                                ? row.newStartDate
                                : row.startDate
                            ).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell align="center" padding="none">
                            {moment(row.newEndDate ? row.newEndDate : row.endDate).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>{row.supplierName}</TableCell>
                          <TableCell>
                            {row.flexReceivedDate
                              ? moment(row.flexReceivedDate).format(
                                  'DD MMM YYYY'
                                )
                              : ''}
                          </TableCell>
                          <TableCell>{row.frequency}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          {updateFlexReceiveDate && (
            <CommonModal
              title="Change Flex Receive Date"
              open
              width="md"
              onYes={addFlexReceiveDate}
              onClose={() => {
                setNewStartDate(null);
                setUpdateFlexReceiveDate(false);
              }}
              saveBtnDisable={!newStartDate}
              successButtonText="Change"
              cancelButtonText="Cancel"
            >
              <DayPicker
                selectedDays={newStartDate}
                onDayClick={handleDayClick}
              />
            </CommonModal>
          )}
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
    </div>
  );
};

const mapState = (state) => ({
  allSites: state.sites.allSites,
  currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  assignFlexDate: assignFlexReceiveDate,
};

export default connect(mapState, mapActions)(FlexDateTable);
